// The active org lives in the first path segment. The tenant with a null or
// empty name is "-" there and in the X-MB-Pro-Org header: an empty header
// would be indistinguishable from an absent one (the home org).
const UNNAMED_ORG_SEGMENT = "-";

export const orgNameToSegment = (name: string | null | undefined) =>
  name ? encodeURIComponent(name) : UNNAMED_ORG_SEGMENT;

export const orgSegmentToName = (segment: string) =>
  segment === UNNAMED_ORG_SEGMENT ? "" : decodeURIComponent(segment);

export const orgNameToApiToken = (name: string | null | undefined) =>
  name || UNNAMED_ORG_SEGMENT;
